module.exports = __webpack_public_path__ + "img/IEC13811.d200f603.png";